import type { BankStatementData, BankTransactionData } from "~/types/trust-account";

export const useTrustBankStatement = () => {
    const uploadTrustBankStatement = async (
        bankStatementData: BankStatementData
    ) => {
        try {
            const response = await $fetch('/api/v1/trust-bank-statement/upload', {
                method: 'POST',
                body: bankStatementData,
            });
            return { data: response, error: null };
        } catch (error) {
            console.error('Error uploading trust bank statement:', error);
            return { data: null, error };
        }
    };

    const getBankStatementById = async (bankStatementId: string) => {
        try {
            const bankStatement = await $fetch(`/api/v1/trust-bank-statement/${bankStatementId}`, {
                method: 'GET',
            });

            return { data: bankStatement, error: null };
        } catch (error) {
            console.error('Error fetching bank statement:', error);
            return { data: null, error };
        }
    };

    const deleteBankStatement = async (bankStatementId: string) => {
        try {
            const bankStatement = await $fetch(`/api/v1/trust-bank-statement/${bankStatementId}`, {
                method: 'DELETE',
            });

            return { data: bankStatement, error: null };
        } catch (error) {
            console.error('Error deleting bank statement:', error);
            return { data: null, error };
        }
    };

    const viewBankStatement = async (bankStatementId: string) => {
        await navigateTo(`/trust-accounting/bank-statement/${bankStatementId}`)
    }

    // TRANSACTION METHODS
    const createBankTransaction = async (bankTransactionData: BankTransactionData) => {
        try {
            const response = await $fetch(`/api/v1/trust-bank-statement/transaction`, {
                method: 'POST',
                body: bankTransactionData,
            });
            return { data: response, error: null };
        } catch (error) {
            console.error('Error creating bank transaction:', error);
            return { data: null, error };
        }
    }

    const deleteBankTransaction = async (bankTransactionId: string) => {
        try {
            const response = await $fetch(`/api/v1/trust-bank-statement/transaction/${bankTransactionId}`, {
                method: 'DELETE',
            });
            return { data: response, error: null };
        } catch (error) {
            console.error('Error deleting bank transaction:', error);
            return { data: null, error };
        }
    }

    const updateBankTransactionById = async (
        bankTransactionId: string,
        bankTransactionData: BankTransactionData
    ) => {
        try {
            const response = await $fetch(`/api/v1/trust-bank-statement/transaction/${bankTransactionId}`, {
                method: 'PUT',
                body: bankTransactionData,
            });
            return { data: response, error: null };
        } catch (error) {
            console.error('Error updating bank transaction:', error);
            return { data: null, error };
        }
    }

    return {
        uploadTrustBankStatement,
        getBankStatementById,
        deleteBankStatement,
        viewBankStatement,
        createBankTransaction,
        deleteBankTransaction,
        updateBankTransactionById
    };
};
